<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar External Id da cobrança
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Id da cobrança</th>
                <td>{{ billing.id }}</td>
              </tr>
              <tr>
                <th>Instituição</th>
                <td>{{ billing.institution_name }}</td>
              </tr>
              <tr>
                <th>Curso</th>
                <td>{{ billing.course_name }}</td>
              </tr>
              <tr>
                <th class="spaced-title">
                  External Id atual
                </th>
                <td class="spaced-cell">
                  {{ billing.external_id || '-' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-body">
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <p>Novo External ID da cobrança:</p>
          <input class="form-control" type="number" v-model="newBillingExternalId">
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="updateBillingExternalId" :disabled="!newBillingExternalId">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BillingsService from 'services/BillingsService';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newBillingExternalId: null,
      inputError: null,
    };
  },
  methods: {
    ...mapActions([
      'loadStudentBillings',
    ]),

    updateBillingExternalId() {
      if (this.newBillingExternalId === this.billing.external_id) {
        this.inputError = 'O novo External ID é igual ao External ID atual.';
        return;
      }

      this.inputError = null;
      this.$loader.show();
      BillingsService.updateBillingExternalId(this.billing.id, this.newBillingExternalId)
        .then(() => {
          this.$alert.notifySuccess('External ID alterado com sucesso.');
          this.loadStudentBillings();
          this.$emit('close');
        })
        .catch((error) => {
          this.inputError = error?.response?.data?.message || 'Erro ao atualizar: contate o suporte.';
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style scoped>
th {
  width: 30%;
}

td {
  width: 70%;
}

.table-striped{
  margin-bottom: 0;
}

.modal-body--scrollable{
  height: 300-x;
}
</style>
